import { getApiCall, postApiCall } from '../../utils/request';
import { FULL_SCREEN_OFF, FULL_SCREEN_ON, GET_SUBJECT_WHITEBOARD, UPLOAD_RECORDING, UPLOAD_RECORDING_FAIL, UPLOAD_RECORDING_START, UPLOAD_RECORDING_SUCCESS } from '../Types/types';
import { returnErrors } from './errorAction';

export const uploadRecording = (type, title, description, subjectId, chapterId, formData) => async (dispatch) => {
    try {
        dispatch({ type: UPLOAD_RECORDING_START });
        const response = await postApiCall(`admin/mycontent/whiteboard/create?type=${type}&subject_id=${subjectId}&chapter_id=${chapterId}&title=${title}&description=${description}`, formData);
        dispatch({ 
            type: UPLOAD_RECORDING_SUCCESS, 
            payload: response.data.data 
        });
        return response.data; // Return the response data for handling in the component
    } catch (error) {
        dispatch({ 
            type: UPLOAD_RECORDING_FAIL,
            payload: error?.response?.data?.message || 'Upload failed'
        });
        throw error; // Re-throw to handle in the component
    }
    finally {
        dispatch({ type: UPLOAD_RECORDING_FAIL });
    }
}

export const getSubjectWhiteboard = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/resource/assigned/subjects`);
        dispatch({ type: GET_SUBJECT_WHITEBOARD, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const fullScreenOn = () => async (dispatch) => {
    dispatch({ type: FULL_SCREEN_ON });
}

export const fullScreenOff = () => async (dispatch) => {
    dispatch({ type: FULL_SCREEN_OFF });
}
    